import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'
import {inspection as endpoint} from '@/configs/endpoints'

export default {
  state: () => ({
    isLoad: false
  }),
  actions: {
    async connectEquipmentMeasurementForSelectedGas (context, data) {
      const response = await api.post(endpoint.zigBeeEquipment(data.params), {body: data.body})

      if (await requestValidation(response)) {
        return response
      } else {
        if (response?.code === 400)
          context.dispatch('getEquipmentsList', { type_inspection: 'gas' })
        return false
      }
    },
    async startMeasurementForSelectedGas (context, data) {
      const response = await api.post(endpoint.startMeasurementForZigBeeEquipment(data.params), {body: data.body})
      if (await requestValidation(response)) {
        return response
      }
    },
    async updateGasMeasurement (context, data) {
      const response = await api.patch(endpoint.updateGas(data.params), { body: data.body })
      return await requestValidation(response)
    }
  }
}
